import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Transporte from "@/pages/Transporte";
import Logistica from "@/pages/Logistica";
import Protocolo from "@/pages/Protocolo";
import CiudadGaraje from "@/pages/CiudadGaraje";
import ChatWidget from "@/components/ChatWidget";
import AdminLogin from "@/pages/AdminLogin";
import AdminFacturas from "@/pages/AdminFacturas";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const RequireAdmin = ({ children }) => {
  if (!localStorage.getItem("gd_admin_token")) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollManager />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/transporte" element={<Transporte />} />
        <Route path="/logistica-deportiva" element={<Logistica />} />
        <Route path="/protocolo" element={<Protocolo />} />
        <Route path="/ciudad-garaje" element={<CiudadGaraje />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminFacturas />
            </RequireAdmin>
          }
        />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatWidget />}
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-void text-slate-200">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-left" />
    </div>
  );
}

export default App;
